import { render } from "./App.vue?vue&type=template&id=a6cf8164"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a6cf8164&lang=css"

import exportComponent from "/Users/tomoiida/Dropbox/LegalNetwork/limar/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__